import React from "react";

const EquipeCommercialLocal_en = () => {
  return (
    <div>
      <section className="shop grid ">
        <div className="container">
          {/** */}
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="team team-list">
                    <div className="team-photo">
                      <img
                        className="img-fluid mx-auto"
                        src="/assets/images/Commerciaux/rahma zalani.jpg"
                        alt="rahma zalani"
                      />
                    </div>
                    <div className="team-description">
                      <div className="team-info" style={{ height: "100px" }}>
                        <h5>
                          <a href="#/"> Rahma ZAALANI</a>
                        </h5>
                        <span>Local Sales Manager Tunisia</span>
                      </div>
                      <div className="team-contact">
                        <span className="call fa fa-phone">
                          {" "}
                          <a href="tel:+21629591207">+(216) 29 591 207</a>
                        </span>
                        <span className="call fa fa-whatsapp">
                          <a href="https://wa.me/+21629591207">
                            +(216) 29 591 207
                          </a>
                        </span>
                        <span className="email">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div style={{ width: "10%", color: "#029acb " }}>
                              <i className="fa fa-envelope-o" />
                            </div>
                            <div>
                              <a href="mailto:Rahma.ZAALANI@sacemgroup.com">
                                {" "}
                                Rahma.ZAALANI@sacemgroup.com
                              </a>
                            </div>
                          </div>
                        </span>
                      </div>
                      <div className="social-icons social-border rounded color-hover clearfix">
                        <ul>
                          <li className="social-linkedin">
                            <a
                              href="https://www.linkedin.com/in/zaalani-rahma-16a91a188/"
                              target="_blank"
                            >
                              <i className="fa fa-linkedin" />
                            </a>
                          </li>
                          <li className="social-linkedin">
                            <a
                              href="https://wa.me/+21629591207"
                              target="_blank"
                            >
                              <i className="fa fa-whatsapp" />
                            </a>
                          </li>
                        </ul>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/** */}
          <div className="row">
            <div className="container">
              <div className="row">
                {/** */}

                {/** */}
                <div
                  className="col-lg-6 col-md-6 sm-mb-30"
                  style={{ marginTop: "30px" }}
                >
                  <div className="card">
                    <div className="card-body">
                      <div className="team team-list">
                        <div className="team-photo">
                          <img
                            className="img-fluid mx-auto"
                            src="/assets/images/Commerciaux/wassim_bedhly.png"
                            alt="Wassim HEDHLY"
                            style={{ aspectRatio: "1 / 1" }}
                          />
                        </div>
                        <div className="team-description">
                          <div
                            className="team-info"
                            style={{ height: "100px" }}
                          >
                            <h5>
                              <a href="#/">Wassim HEDHLY</a>
                            </h5>
                            <span>Sales Representative, North Tunis</span>
                          </div>
                          <div className="team-contact">
                            <span className="call fa fa-phone">
                              {" "}
                              <a href="tel:+21629922618">+(216) 29 922 618</a>
                            </span>
                            <span className="call fa fa-whatsapp">
                              <a href="https://wa.me/+21629922618">
                                +(216) 29 922 618
                              </a>
                            </span>
                            <span className="email">
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <div
                                  style={{ width: "10%", color: "#029acb " }}
                                >
                                  <i className="fa fa-envelope-o" />
                                </div>
                                <div>
                                  <a href="mailto:Wassim.HEDHLY@sacemgroup.com">
                                    {" "}
                                    Wassim.HEDHLY@sacemgroup.com
                                  </a>
                                </div>
                              </div>
                            </span>
                          </div>
                          <div className="social-icons social-border rounded color-hover clearfix">
                            <ul>
                              <li className="social-linkedin">
                                <a
                                  href="https://tn.linkedin.com/company/sacem-industries1966"
                                  target="_blank"
                                >
                                  <i className="fa fa-linkedin" />
                                </a>
                              </li>
                              <li className="social-linkedin">
                                <a
                                  href="https://wa.me/+21629922618"
                                  target="_blank"
                                >
                                  <i className="fa fa-whatsapp" />
                                </a>
                              </li>
                            </ul>
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/** */}
                <div
                  className="col-lg-6 col-md-6 sm-mb-30"
                  style={{ marginTop: "30px" }}
                >
                  <div className="card">
                    <div className="card-body">
                      <div className="team team-list">
                        <div className="team-photo">
                          <img
                            className="img-fluid mx-auto"
                            src="/assets/images/Commerciaux/anis_tbarki.png"
                            alt="Anis TABARKI"
                            style={{ aspectRatio: "1 / 1" }}
                          />
                        </div>
                        <div className="team-description">
                          <div
                            className="team-info"
                            style={{ height: "100px" }}
                          >
                            <h5>
                              <a href="#/"> Anis TABARKI</a>
                            </h5>
                            <span>
                              After-Sales Service Representative, North Tunis
                            </span>
                          </div>
                          <div className="team-contact">
                            <span className="call fa fa-phone">
                              {" "}
                              <a href="tel:+21628505129">+(216) 28 505 129</a>
                            </span>
                            <span className="call fa fa-whatsapp">
                              {" "}
                              <a href="https://wa.me/+21628505129">
                                +(216) 28 505 129
                              </a>
                            </span>
                            <span className="email">
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <div
                                  style={{ width: "10%", color: "#029acb " }}
                                >
                                  <i className="fa fa-envelope-o" />
                                </div>
                                <div>
                                  <a href="mailto:Anis.TABARKI@sacemgroup.com">
                                    {" "}
                                    Anis.TABARKI@sacemgroup.com
                                  </a>
                                </div>
                              </div>
                            </span>
                          </div>
                          <div className="social-icons social-border rounded color-hover clearfix">
                            <ul>
                              <li className="social-linkedin">
                                <a
                                  href="https://tn.linkedin.com/company/sacem-industries1966"
                                  target="_blank"
                                >
                                  <i className="fa fa-linkedin" />
                                </a>
                              </li>
                              <li className="social-linkedin">
                                <a
                                  href="https://wa.me/+21628505129"
                                  target="_blank"
                                >
                                  <i className="fa fa-whatsapp" />
                                </a>
                              </li>
                            </ul>
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/** */}

                <div
                  className="col-lg-6 col-md-6 sm-mb-30"
                  style={{ marginTop: "30px" }}
                >
                  <div className="card">
                    <div className="card-body">
                      <div className="team team-list">
                        <div className="team-photo">
                          <img
                            className="img-fluid mx-auto"
                            src="/assets/images/Commerciaux/yahia_heni.png"
                            alt="Yahia HENI"
                            style={{ aspectRatio: "1 / 1" }}
                          />
                        </div>
                        <div className="team-description">
                          <div
                            className="team-info"
                            style={{ height: "100px" }}
                          >
                            <h5>
                              <a href="#/">Yahia HENI</a>
                            </h5>
                            <span>
                              Sales Representative, Central-South Region
                            </span>
                          </div>
                          <div className="team-contact">
                            <span className="call fa fa-phone">
                              {" "}
                              <a href="tel:+21629922645">+(216) 29 922 645</a>
                            </span>
                            <span className="call fa fa-whatsapp">
                              {" "}
                              <a href="https://wa.me/+21629922645">
                                +(216) 29 922 645
                              </a>
                            </span>
                            <span className="email">
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <div
                                  style={{ width: "10%", color: "#029acb " }}
                                >
                                  <i className="fa fa-envelope-o" />
                                </div>
                                <div>
                                  <a href="mailto:Yahia.HENI@sacemindustries.com">
                                    {" "}
                                    Yahia.HENI@sacemindustries.com
                                  </a>
                                </div>
                              </div>
                            </span>
                          </div>
                          <div className="social-icons social-border rounded color-hover clearfix">
                            <ul>
                              <li className="social-linkedin">
                                <a
                                  href="https://tn.linkedin.com/company/sacem-industries1966"
                                  target="_blank"
                                >
                                  <i className="fa fa-linkedin" />
                                </a>
                              </li>
                              <li className="social-linkedin">
                                <a
                                  href="https://wa.me/21629922645"
                                  target="_blank"
                                >
                                  <i className="fa fa-whatsapp" />
                                </a>
                              </li>
                            </ul>
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/** */}

                <div
                  className="col-lg-6 col-md-6 sm-mb-30"
                  style={{ marginTop: "30px" }}
                >
                  <div className="card">
                    <div className="card-body">
                      <div className="team team-list">
                        <div className="team-photo">
                          <img
                            className="img-fluid mx-auto"
                            src="/assets/images/Commerciaux/nacim_saafi.png"
                            alt="Nacim SAAFI"
                            style={{ aspectRatio: "1 / 1" }}
                          />
                        </div>
                        <div className="team-description">
                          <div
                            className="team-info"
                            style={{ height: "100px" }}
                          >
                            <h5>
                              <a href="#/">Nacim SAAFI</a>
                            </h5>
                            <span>
                              After-Sales Service Representative, Central-South
                              Region
                            </span>
                          </div>
                          <div className="team-contact">
                            <span className="call fa fa-phone">
                              {" "}
                              <a href="tel:+21629281376">+(216) 29 281 376</a>
                            </span>
                            <span className="call fa fa-whatsapp">
                              <a href="https://wa.me/+21629281376">
                                +(216) 29 281 376
                              </a>
                            </span>
                            <span className="email">
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <div
                                  style={{ width: "10%", color: "#029acb " }}
                                >
                                  <i className="fa fa-envelope-o" />
                                </div>
                                <div>
                                  <a href="mailto:Nacim.SAAFI@sacemgroup.com">
                                    {" "}
                                    Nacim.SAAFI@sacemgroup.com
                                  </a>
                                </div>
                              </div>
                            </span>
                          </div>
                          <div className="social-icons social-border rounded color-hover clearfix">
                            <ul>
                              <li className="social-linkedin">
                                <a
                                  href="https://tn.linkedin.com/company/sacem-industries1966"
                                  target="_blank"
                                >
                                  <i className="fa fa-linkedin" />
                                </a>
                              </li>
                              <li className="social-linkedin">
                                <a
                                  href="https://wa.me/+21629281376"
                                  target="_blank"
                                >
                                  <i className="fa fa-whatsapp" />
                                </a>
                              </li>
                            </ul>
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/** */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EquipeCommercialLocal_en;
